import { useMemo, memo } from 'react'
import { Theme } from '@mui/material/styles'
import * as CSSTypes from 'csstype'
import { observer } from 'mobx-react'
import { Typography } from '@mui/material'

import CategoryLayout from 'components/Layout/Category'
import { useStores } from 'stores/utils/hooks/useStores'
import { CONFIG_MOBILEDE } from 'config/utils/config'
import useEmotionStyles from 'hooks/useEmotionStyles'

const styles = (theme: Theme) => ({
  progressBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '8px'
  },
  stepNumber: {
    display: 'flex',
    flexDirection: 'row' as CSSTypes.Property.FlexDirection,
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  activeNumber: {
    backgroundColor: `${theme.palette.grey[600]} !important`
  },
  defaultNumber: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: '50%',
    height: '40px',
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  number: {
    color: '#ffffff'
  },
  active: {
    backgroundColor: `${theme.palette.primary[400]} !important`
  },
  defaultStep: {
    width: '100%',
    height: '10px',
    backgroundColor: theme.palette.primary[200],

    '&:last-child': {
      borderRadius: '0px 2px 2px 0px'
    },

    '&:first-child': {
      borderRadius: '2px 0px 0px 2px'
    }
  }
})

interface ProgressProps {
  allSteps?: number
}

const SmavaProgressIndicator = observer(({ allSteps = 5 }: ProgressProps) => {
  const {
    page: { getPageIndex },
    navigation: { currentPageInSession, currentConfigInSession }
  } = useStores()
  const pageIndex = getPageIndex(currentPageInSession || '')
  const index =
    currentConfigInSession === CONFIG_MOBILEDE ? pageIndex : pageIndex - 1

  const styleProps = useMemo(
    () => ({
      allSteps,
      index
    }),
    [allSteps, index]
  )
  const {
    progressBar,
    active,
    defaultStep,
    stepNumber,
    activeNumber,
    defaultNumber,
    number
  } = useEmotionStyles(styles)

  if (!currentPageInSession) {
    return null
  }

  return (
    <CategoryLayout>
      <div className={stepNumber}>
        {[...Array(allSteps)].map((_, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`step-index-${i}`}
            className={`${defaultNumber} ${i === index ? activeNumber : ''}`}
          >
            <Typography variant="h4" className={number}>
              {i + 1}
            </Typography>
          </div>
        ))}
      </div>
      <div className={progressBar}>
        {[...Array(allSteps)].map((_, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`step-index-${i}`}
            className={`${defaultStep} ${i <= index ? active : ''}`}
          />
        ))}
      </div>
    </CategoryLayout>
  )
})

export default memo(SmavaProgressIndicator)
